import { SignUpPage } from "@grafit/frontend-auth/sign-up-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_no_auth/sign-up")({
  component: SignUpPage,
});
